module.exports = __webpack_public_path__ + "static/media/logo_pensetroque_circle.a2215762.png";